module.exports = __webpack_public_path__ + "static/media/login-image-desktop@2x.bde0cac6.png";